import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { navigatorLanguage } from "../../i18n";
import ModalLanguage from "components/common/tools/ModalLanguage";
import { getElementByUuid } from "utils/data/Content";
import { transformSlug } from "utils/Translations";
import "css/admin/utils/module-language.scss";

class ModuleLanguage extends Component {
  constructor(props) {
    super(props);

    const { items, item } = props;
    this.state = {
      items: items || [item],
      modalLangOpen: false,
    };
  }

  componentDidUpdate() {
    const { items, item } = this.props;
    const newItems = items || [item];
    if (JSON.stringify(newItems) != JSON.stringify(this.state.items)) {
      this.setState({
        items: newItems,
      });
    }
  }

  componentDidMount() {
    const { items } = this.state;

    const itemsWithTranslation = items.map((item) => {
      if (item.translations?.length === 0) {
        const lang = {
          value: navigatorLanguage,
        };

        item = this.createDefaultLang(item, lang);
      }
      return item;
    });
    const hasSingleItem = this.props.item;

    this.props.onUpdate(
      hasSingleItem ? itemsWithTranslation[0] : itemsWithTranslation,
    );
  }

  doesLangExist = (item, lang, language_uuid) => {
    const { isApiV4 } = this.props;
    let exist = false;
    item.translations.forEach((item) => {
      if (isApiV4) {
        if (item.language_uuid === language_uuid) exist = true;
      } else if (item.language === lang) exist = true;
    });
    return exist;
  };

  onAddLang = (lang) => {
    let { items } = this.state;
    const {
      canUpdate,
      customProperties,
      isApiV4,
      hasSlug,
      onAddLanguage,
      onError,
      onUpdate,
      onCreateTranslation,
      customNewLang,
    } = this.props;

    if (!canUpdate) {
      this.setState({ modalLangOpen: false });
      onError();
      return;
    }

    const language_uuid = isApiV4 ? this.getLanguageUuid(lang.value) : null;

    items = items.map((item) => {
      const currentDefault = item.translations_indexes.default.true[0];
      const defaultTranslate = item.translations[currentDefault];

      if (lang && lang.value) {
        let langExist = false;
        if (isApiV4) {
          langExist = this.doesLangExist(item, null, language_uuid);
        } else {
          langExist = this.doesLangExist(item, lang.value);
        }

        if (!langExist) {
          if (customNewLang) {
            const newItem = {
              language: lang.value,
              default: false,
              ...customNewLang,
            };

            item.translations.push(newItem);
          } else {
            const new_item = {
              default: false,
              name: hasSlug
                ? `${defaultTranslate.name} ${lang.value}`
                : `${defaultTranslate.name}`,
              cover_picture_16_6_url: defaultTranslate.cover_picture_16_6_url,
              cover_picture_16_9_url: defaultTranslate.cover_picture_16_9_url,
            };

            if (hasSlug)
              new_item.slug = transformSlug(
                `${defaultTranslate.name} ${lang.value}`,
              );

            if (isApiV4) {
              new_item.language_uuid = language_uuid;
            } else {
              new_item.language = lang.value;
            }

            customProperties?.forEach((prop) => {
              new_item[prop] = defaultTranslate[prop];
            });

            if (defaultTranslate.cover_picture_16_6) {
              new_item.cover_picture_16_6 = defaultTranslate.cover_picture_16_6;
            }

            if (defaultTranslate.cover_picture_16_9) {
              new_item.cover_picture_16_9 = defaultTranslate.cover_picture_16_9;
            }

            item.translations.push(new_item);
          }

          const index = item.translations.length - 1;
          if (isApiV4) {
            item.translations_indexes.language_uuid[language_uuid] = [index];
          } else {
            item.translations_indexes.language[lang.value] = [index];
          }
        }
      }
      return item;
    });

    onCreateTranslation
      ? onCreateTranslation({
          languageId: language_uuid,
          updatedItem: items[0],
        })
      : onUpdate(this.props.items ? items : items[0]);
    onAddLanguage && onAddLanguage(this.props.items ? items : items[0]);

    this.setState({ items, modalLangOpen: false });
  };

  getLanguageUuid = (language) => {
    let language_uuid = null;
    this.props.languages.data.forEach((it) => {
      if (it.language === language) {
        language_uuid = it.uuid;
      }
    });
    return language_uuid;
  };

  createDefaultLang = (item, lang) => {
    const { customProperties, isApiV4 } = this.props;

    if (lang && lang.value) {
      const language_uuid = isApiV4 ? this.getLanguageUuid(lang.value) : null;
      const new_item = {
        default: true,
        name: "",
      };

      if (isApiV4) {
        new_item.language_uuid = language_uuid;
      } else {
        new_item.language = lang.value;
      }

      customProperties?.forEach((prop) => {
        new_item[prop] = "";
      });

      item.translations.push(new_item);

      const index = item.translations.length - 1;
      item.translations_indexes.default = {
        true: [index],
      };
      if (isApiV4) {
        item.translations_indexes.language_uuid[language_uuid] = [index];
      } else {
        item.translations_indexes.language[lang.value] = [index];
      }
    }

    return item;
  };

  onRemoveLang = (lang) => {
    const { items } = this.state;
    const { isApiV4 } = this.props;

    const language_uuid = isApiV4 ? this.getLanguageUuid(lang) : null;
    const updatedItems = items.map((item) => {
      const index = isApiV4
        ? item.translations_indexes.language_uuid[language_uuid]
        : item.translations_indexes.language[lang];
      const indexDefault = item.translations_indexes.default.true[0];

      item.translations.splice(index, 1);

      if (isApiV4) {
        delete item.translations_indexes.language_uuid[language_uuid];
      } else {
        delete item.translations_indexes.language[lang];
      }

      if (index < indexDefault) {
        item.translations_indexes.default.true[0] = indexDefault - 1;
      }

      this.computeLangIndex(item);
      return { ...item };
    });

    this.props.onUpdate(this.props.items ? updatedItems : updatedItems[0]);
    this.setState({
      items: updatedItems,
      modalLangOpen: false,
    });
  };

  computeLangIndex = (item) => {
    const { isApiV4 } = this.props;
    if (isApiV4) {
      item.translations_indexes.language_uuid = {};
      item.translations.forEach((t, idx) => {
        item.translations_indexes.language_uuid[t.language_uuid] = [idx];
      });
    } else {
      item.translations_indexes.language = {};
      item.translations.forEach((t, index) => {
        item.translations_indexes.language[t.language] = [index];
      });
    }
  };

  setDefaultLang = (lang, isDisabled, e) => {
    const { isApiV4 } = this.props;
    const { items } = this.state;

    // do not set default lang when we click on delete icon
    if (e.target.className === "material-icons editor-multi-icons") return;

    const language_uuid = isApiV4 ? this.getLanguageUuid(lang) : null;

    if (isDisabled) return;

    items.map((item) => {
      const currentDefault = item.translations_indexes.default.true[0];
      const targetIndex =
        isApiV4 &&
        item.translations_indexes?.language_uuid &&
        item.translations_indexes?.language_uuid[language_uuid]
          ? item.translations_indexes?.language_uuid[language_uuid][0]
          : item.translations_indexes.language[lang][0];

      item.translations[currentDefault].default = false;
      item.translations[targetIndex].default = true;

      item.translations_indexes.default.true = [targetIndex];
      return item;
    });

    this.props.onUpdate(this.props.items ? items : items[0]);
    this.setState({ items });
  };

  openModal = () => {
    this.setState({
      modalLangOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalLangOpen: false,
    });
  };

  render() {
    const { disabled, t, items, languages, isApiV4, disabledTooltipMessage } =
      this.props;
    const item = items ? items[0] : this.props.item;
    const isDisabled = item.status === "archived" || disabled;

    return (
      <div className="editor-form-languages flex">
        {item.translations?.map((translation) => {
          let language = null;
          if (isApiV4) {
            language = getElementByUuid(
              translation.language_uuid,
              languages,
            ).language;
          } else {
            language = translation.language;
          }
          return (
            <div
              key={`languages${language}`}
              className={`editor-form-language ${translation.default ? "editor-form-language-default" : ""}`}
              onClick={(e) => this.setDefaultLang(language, isDisabled, e)}
            >
              <div className="editor-form-language-name">
                {t(`languages:langs.${language}`)}
                {!isDisabled && !translation.default && (
                  <span
                    className="editor-form-language-delete"
                    onClick={() => this.onRemoveLang(language)}
                  >
                    <i className="material-icons editor-multi-icons">cancel</i>
                  </span>
                )}
              </div>
              {translation.default && (
                <div className="editor-form-language-default-caption">
                  {t("default")}
                </div>
              )}
            </div>
          );
        })}
        {!isDisabled && (
          <div className="editor-form-languages-add">
            <div className="editor-form-languages-add-btn">
              <i
                style={{
                  cursor: disabledTooltipMessage ? "not-allowed" : "pointer",
                }}
                data-tooltip-content={disabledTooltipMessage}
                data-tooltip-id={APP_TOOLTIP_ID}
                className="material-icons editor-multi-icons"
                onClick={disabledTooltipMessage ? undefined : this.openModal}
              >
                control_point
              </i>
            </div>
            <ModalLanguage
              onSubmit={this.onAddLang}
              onCancel={this.closeModal}
              isOpen={this.state.modalLangOpen}
              transitionName="modal-anim"
              selectedTranslation={item.translations}
            />
          </div>
        )}
      </div>
    );
  }
}

ModuleLanguage.propTypes = {
  canUpdate: PropTypes.bool,
  disabled: PropTypes.bool,
  customProperties: PropTypes.array,
  items: PropTypes.array,
  item: PropTypes.object,
  onError: PropTypes.func,
  onUpdate: PropTypes.func.isRequired,
  onAddLanguage: PropTypes.func,
  onCreateTranslation: PropTypes.func,
  hasSlug: PropTypes.bool,
  isApiV4: PropTypes.bool,
  languages: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  disabledTooltipMessage: PropTypes.string,
  customNewLang: PropTypes.object,
};

ModuleLanguage.defaultProps = {
  customProperties: [],
  canUpdate: true,
  hasSlug: false,
  isApiV4: false,
  onCreateTranslation: () => {},
  disabledTooltipMessage: null,
  customNewLang: undefined,
};

const mapStateToProps = (state) => {
  const { languages } = state.fetchReducer;

  return { languages };
};

export default connect(mapStateToProps)(
  withTranslation(["editor-smartlist", "languages"])(ModuleLanguage),
);
